module.exports = __webpack_public_path__ + "img/logo.8fff54dc.png";